import {useCallback, useMemo} from 'react';
import {type AstView, findParentOfNodeById} from 'rendition-core';
import {useNodeNameEditStore} from 'stores/nodeEdit';

export const useNodeNameEdit = (
    view: AstView,
    flexNodes: Array<string>,
    absNodes: Array<string>,
    completeNaming?: () => void
) => {
    const orderedNodes = useMemo(() => [...flexNodes, ...absNodes], [absNodes, flexNodes]);

    const editingNodeNameId = useNodeNameEditStore.use.editingNodeNameId();
    const stopEditing = useNodeNameEditStore.use.stopEditing();
    const stopEditingAndSaveNodeId = useNodeNameEditStore.use.stopEditingAndSaveNodeId();
    const startEditing = useNodeNameEditStore.use.startEditing();

    const jumpToEditNextNode = useCallback(
        (startingNode?: string) => {
            const parent = findParentOfNodeById(view.tree, startingNode || editingNodeNameId || '');
            if (!parent) {
                return stopEditing();
            }

            const nodeIndex = orderedNodes.findIndex((n) => n === editingNodeNameId) || 0;

            if (nodeIndex + 1 >= orderedNodes.length) {
                stopEditingAndSaveNodeId();
                return completeNaming?.();
            }

            return startEditing(orderedNodes[nodeIndex + 1] || '');
        },
        [
            completeNaming,
            editingNodeNameId,
            orderedNodes,
            startEditing,
            stopEditing,
            stopEditingAndSaveNodeId,
            view.tree,
        ]
    );

    return {
        jumpToEditNextNode,
    };
};
